<!-- SPDX-FileCopyrightText: © 2025 Schneider Electric SPDX-License-Identifier: Apache-2.0 -->
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.95 12.39 2.06 4.76l.79-.61 5.11 6.62 5.23-6.63.78.62z"/></svg>